import { cn } from '@latitude/token-utils';
import type { PopoverTriggerProps } from '@radix-ui/react-popover';
import { Trigger as PrimitiveTrigger } from '@radix-ui/react-popover';
import type { FC } from 'react';

export const Trigger: FC<PopoverTriggerProps> = ({ children, ...rest }) => {
  return (
    <PrimitiveTrigger
      {...rest}
      className={cn([
        'focus-visible:outline',
        'focus-visible:outline-offset-2',
        'focus-visible:outline-2',
        'focus-visible:outline-color-ref-ui-focus-default',
        // Tailwind emits focus-visible after focus, so the ring above still wins for keyboard focus
        'focus:outline-none',
        '[&>*]:cursor-pointer',
      ])}
    >
      {children}
    </PrimitiveTrigger>
  );
};
